import styled from 'styled-components';

export default styled.a`
  color: ${({ theme }) => theme.color.text.brand.default};

  &:hover {
    cursor: pointer;
    color: ${({ theme }) => theme.color.text.brand.strong};
  }
`;
